import React from "react"
import { StyleSheet } from "~/ui/primitives"
import { BetweenFlex, Text } from "~components/El"
import MessageTime from "./message-time"

/** 渐变卡片（红包/转账）底部分隔线颜色 */
export const GRADIENT_CARD_DIVIDER_COLOR = "rgba(255, 255, 255, 0.28)"

type GradientCardFooterProps = {
  label: string
  time: Date
  textColor: string
}

export const GradientCardFooter: React.FC<GradientCardFooterProps> = ({ label, time, textColor }) => (
  <BetweenFlex
    width="100%"
    height="30px"
    py="8px"
    borderTopWidth={StyleSheet.hairlineWidth}
    borderTopColor={GRADIENT_CARD_DIVIDER_COLOR}
    borderTopStyle="solid"
  >
    <Text fontSize={10} color={textColor}>
      {label}
    </Text>
    <MessageTime color={textColor} fontSize={10} time={time} />
  </BetweenFlex>
)
